module.exports = __webpack_public_path__ + "img/rank5.288a6535.png";